<template>
  <div class="faq App-faq bg-white">
    <div class="inner text-center">
      <h1 class="h1 title">{{ $t('faq.title') }}</h1>
      <div class="content text-left">
        <faq></faq>
      </div>
    </div>
  </div>
</template>

<script>
  import { META_FAQ } from '../../mixins/metadata.js'
  import Faq2 from './component/faq.vue'

  export default {
    mixins: [META_FAQ],
    name: 'FaqPage',
    components: {
      'faq': Faq2,
    },
    head: {
      title: {
        inner: 'よくあるご質問一覧｜思いがけないアイデアと出会う。プロフェッショナル同士の予定調和のない雑談'
      },
      meta: [
        { name: 'keywords', content: '思いがけないアイデアと出会う。プロフェッショナル同士の予定調和のない雑談' },
        { name: 'description', content: '思いがけないアイデアと出会う。プロフェッショナル同士の予定調和のない雑談' },
      ]
    },
  }
</script>

<style lang="scss">
.js-accordion{
  &--trigger{
    position: relative;
    transition: all 0.2s ease-in;
  }
  &--target{
    overflow: hidden;
    transition: height 0.4s ease-in-out;
  }
  &-enter-active{
    animation-duration: 1s;
    animation-fill-mode: both;
    animation-name: js-accordion--anime__opend;
  }
  &-leave-active{
    animation-duration: 1s;
    animation-fill-mode: both;
    animation-name: js-accordion--anime__closed;
  }
}
@keyframes js-accordion--anime__opend {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
   }
}
@keyframes js-accordion--anime__closed {
  0% {
   opacity: 1;
  }

  100% {
    opacity: 0;
  }
}
</style>
